import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";


export const GetUserDetailById = (params: any) =>
  GET_ENC(`${BASE_URL}/api/User/GetDetailById?` + params, null);

export const GetUserDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/User/GetDetail?` + params, null);

export const GetUserList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/User/GetList?` + params, null);

export const CreateUser = (data: any) =>
  POST_ENC(`${BASE_URL}/api/User/Create`, data);

export const GetSaveUserOrgBranchSelection = (params: any) =>
  GET_ENC(`${BASE_URL}/api/User/GetSaveUserOrgBranchSelection?` + params, null);

export const DeleteUser = (data: any) =>
  POST_ENC(`${BASE_URL}/api/User/Delete`, data);

export const UpdateUser = (data: any) =>
  POST_ENC(`${BASE_URL}/api/User/Update`, data);

export const UpdatePassword = (data: any) =>
  POST_ENC(`${BASE_URL}/api/User/UpdatePassword`, data);

export const SendInvite = (data: any) =>
  POST_ENC(`${BASE_URL}/api/User/SendInvite`, data);

export const ReInvite = (data :any) =>{
  POST_ENC(`${BASE_URL}/api/User/ReInvite`,data);
}

export const UpdateDefaultInvoice = (data: any) =>
  POST_ENC(`${BASE_URL}/api/User/UpdateDefaultInvoice`, data);

export const UpdateDefaultPrescription = (data: any) =>
  POST_ENC(`${BASE_URL}/api/User/UpdateDefaultPrescription`, data);

export const UpdateUserSecurity = (data: any) =>
  POST_ENC(`${BASE_URL}/api/User/UpdateUserSecurity`, data);